exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"referenceprojectdetail.css","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a690c46a","scoped":true,"hasInlineConfig":false}!./src/components/search/referenceprojectsearch/detail/referenceprojectdetail.css
// module id = H/0v
// module chunks = 1